import { render } from "./PageRangeBikouTable.vue?vue&type=template&id=290c29c8&scoped=true"
import script from "./PageRangeBikouTable.vue?vue&type=script&lang=js"
export * from "./PageRangeBikouTable.vue?vue&type=script&lang=js"

import "./PageRangeBikouTable.vue?vue&type=style&index=0&id=290c29c8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290c29c8"]])

export default __exports__